import {
  Column,
  CreateDateColumn,
  DeleteDateColumn,
  Entity,
  JoinTable,
  ManyToMany,
  PrimaryGeneratedColumn
} from 'typeorm';
import { TIPO_DESCONTO_PORCENTAGEM } from '../constants';
import Cliente from './Cliente';

@Entity()
export class Cupom {
  @PrimaryGeneratedColumn()
  id!: number;

  @Column({ unique: true })
  codigo: string = '';

  @Column()
  tipo: string = TIPO_DESCONTO_PORCENTAGEM;

  @Column()
  valor: number = 0;

  @Column()
  validade: Date = new Date();

  @Column()
  ativo: boolean = true;

  @Column()
  maximoUsos: number = 10;

  @Column()
  maximoUsosPorCliente: number = 1;

  @Column()
  valorMinimoPedido: number = 0;

  @ManyToMany(() => Cliente)
  @JoinTable({ name: 'cliente_usou_cupom' })
  clientes!: Cliente[];

  @CreateDateColumn({ select: false })
  createdAt!: Date;

  @DeleteDateColumn({ select: false })
  deletedAt!: Date;
}

export default Cupom;
